@let user = user$ | async;
<div
  class="wrapper"
  [ngStyle]="styles()"
  [attr.data-userid]="dataUserId()"
  *pluginsUserProfileLink="
    user?.id;
    enabled: profileLinkEnabled() && user?.type === 'user'
  "
>
  @let countVal = count();
  <div
    class="user-name"
    [title]="
      titleTranslationKey()
        | translate
          : {
              name: name(),
              count: countVal ? (countVal | abbreviateNum | async) : undefined,
            }
    "
  >
    @switch (status()) {
      @case ('pending') {
        <div
          class="user-name__name user-name__name--pending"
          [pluginsLineLimit]="lineLimit()"
        ></div>
      }
      @case ('success') {
        <p class="user-name__name" [pluginsLineLimit]="lineLimit()">
          {{ nameTranslationKey() | translate: { name: name() } }}
        </p>
      }
      @case ('error') {
        <p
          class="user-name__name user-name__name--error"
          [pluginsLineLimit]="lineLimit()"
        >
          {{ errorMessage | translate }}
        </p>
      }
    }
  </div>
</div>
